import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';


@NgModule({
	declarations: [],
	imports: [
		CommonModule
	]
})
export class SvgIconsModule {
	constructor(iconReg: MatIconRegistry, sanitizer: DomSanitizer) {
		iconReg.addSvgIcon('arrow-solid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/arrow-solid.svg'));
		iconReg.addSvgIcon('globe-glyph', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/globe-glyph.svg'));
		iconReg.addSvgIcon('home-solid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/home-solid.svg'));
		iconReg.addSvgIcon('person-solid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/person-solid.svg'));
		iconReg.addSvgIcon('material-logout', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/material_logout.svg'));
	}
}
